import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { LocalstorageService } from "./localstorage.service";
import { CovidTestData } from "../covid-test/covid-test.component";
import * as moment from "moment";
import { ExternalTestData } from "../external-test-upload/external-test-upload.component";

const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

@Injectable({
  providedIn: "root",
})
export class CameraService {


  constructor(private router: Router,
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private localstorageService: LocalstorageService) { }

  savePhoto(pictures: any) {
    console.log(pictures)
    let authDetails = this.localstorageService.getAuth();
    if (authDetails == undefined) return;

    let formData: FormData = new FormData();
    pictures.forEach((element, index) => {

      if (element.includes("data")) {
        var re = /data:[a-z]+\/+[a-z]+\;+base64,/gi;
        var base64String = element.toString().replace(re, "");

        var myFileType = element.substring(
          element.indexOf("/") + 1,
          element.lastIndexOf(";")
        );

        var myBlobType = element.substring(
          element.lastIndexOf("data:") + 5,
          element.lastIndexOf(";")
        );

        let blob = b64toBlob(base64String, myBlobType);
        formData.append('files', blob, index + '.' + myFileType);
      }
      else {
        let blob = b64toBlob(element);
        formData.append('files', blob, index + '.jpg');
      }
    });

    //const headers = new HttpHeaders().append('Content-Disposition', 'mulipart/form-data');
    console.log('savephoto', formData);
    return this.http.post(
      this.baseUrl + "api/upload/image/vaxcard/" + authDetails.employeeInfo.corpId, formData,
    );
  }

  uploadRTWFile(pictures: any, surveyEntryId: number) {
    console.log(pictures)
    let authDetails = this.localstorageService.getAuth();
    /*if (authDetails == undefined) return;*/

    let formData: FormData = new FormData();
    pictures.forEach((element, index) => {

      if (element.includes("data")) {
        var re = /data:[a-z]+\/+[a-z]+\;+base64,/gi;
        var base64String = element.toString().replace(re, "");

        var myFileType = element.substring(
          element.indexOf("/") + 1,
          element.lastIndexOf(";")
        );

        var myBlobType = element.substring(
          element.lastIndexOf("data:") + 5,
          element.lastIndexOf(";")
        );

        let blob = b64toBlob(base64String, myBlobType);
        formData.append('files', blob, index + '.' + myFileType);
      }
      else {
        let blob = b64toBlob(element);
        formData.append('files', blob, index + '.jpg');
      }
    });

    //const headers = new HttpHeaders().append('Content-Disposition', 'mulipart/form-data');
    console.log('savephoto', formData);
    return this.http.post(
      this.baseUrl + "api/upload/image/returntowork/" + surveyEntryId, formData,
    );
  }

  saveCovidTestData(covidTestData: CovidTestData) {
    console.log('saveCovidTestData', covidTestData)
    let authDetails = this.localstorageService.getAuth();
    if (authDetails == undefined) return;

    let formData: FormData = new FormData();
    covidTestData.files.forEach((element, index) => {

      if (element.includes("data")) {
        var re = /data:[a-z]+\/+[a-z]+\;+base64,/gi;
        var base64String = element.toString().replace(re, "");

        var myFileType = element.substring(
          element.indexOf("/") + 1,
          element.lastIndexOf(";")
        );

        var myBlobType = element.substring(
          element.lastIndexOf("data:") + 5,
          element.lastIndexOf(";")
        );

        let blob = b64toBlob(base64String, myBlobType);
        formData.append('files', blob, index + '.' + myFileType);
      }
      else {
        let blob = b64toBlob(element);
        formData.append('files', blob, index + '.jpg');
      }
    });

    formData.append('testDate', moment(covidTestData.testDate).format("YYYY-MM-DD"));
    formData.append('testType', covidTestData.testType.toString());
    formData.append('testResult', covidTestData.testResult.toString());
    formData.append('testObserver', covidTestData.testObserver.toString());
    formData.append('testLocationId', covidTestData.testLocationId.toString());
    formData.append('testLotNumber', covidTestData.testLotNumber.toString());
    formData.append('purpose', covidTestData.purpose.toString());
    formData.append('testExpirationDate', moment(covidTestData.expirationDate).format("YYYY-MM-DD"));
    formData.append('amendExpirationDate', moment(covidTestData.amendExpirationDate).format("YYYY-MM-DD"));
    console.log('covid test form data', formData)
    return this.http.post(
      this.baseUrl + "api/upload/file/returntowork/" + authDetails.employeeInfo.corpId, formData
    );
  }

  saveExternalCovidTestData(covidTestData: ExternalTestData) {
    var fileCount = covidTestData.files.length;
    if (fileCount > 1) {
      covidTestData.files = covidTestData.files.slice(fileCount - 1, fileCount);
    }
    console.log('saveCovidTestData', covidTestData);
    let authDetails = this.localstorageService.getAuth();
    if (authDetails == undefined) return;

    let formData: FormData = new FormData();

    covidTestData.files.forEach((element, index) => {

      if (element.includes("data")) {
        var re = /data:[a-z]+\/+[a-z]+\;+base64,/gi;
        var base64String = element.toString().replace(re, "");

        var myFileType = element.substring(
          element.indexOf("/") + 1,
          element.lastIndexOf(";")
        );

        var myBlobType = element.substring(
          element.lastIndexOf("data:") + 5,
          element.lastIndexOf(";")
        );

        let blob = b64toBlob(base64String, myBlobType);
        formData.append('files', blob, index + '.' + myFileType);
      }
      else {
        let blob = b64toBlob(element);
        formData.append('files', blob, index + '.jpg');
      }
    });

    formData.append('testDate', moment(covidTestData.testDate).format("YYYY-MM-DD"));
    formData.append('dateOfBirth', moment(covidTestData.dateOfBirth).format("YYYY-MM-DD"));
    formData.append('testResult', covidTestData.testResult.toString());
    formData.append('nameOnTest', covidTestData.nameOnTest.toString());
    formData.append('testMethod', covidTestData.testMethod.toString());

    return this.http.post(this.baseUrl + "api/upload/image/externaltest/" + covidTestData.surveyEntryId, formData);

  }

}
